const TERMINALS = ['ITS', 'APM', 'LBCT', 'TTI'];
const SSLS = ['HMM', 'ONE', 'MSC', 'CMA'];
const CITIES = ['Long Beach', 'Los Angeles', 'Oakland', 'Seattle'];

const HEADER_HINT =
  'Target = delivery appointment + buffer + drive to terminal';

function buildDropPickPlannerCard(index) {
  const i = index + 1;
  const term = TERMINALS[index % TERMINALS.length];
  const ssl = SSLS[index % SSLS.length];
  const city = CITIES[index % CITIES.length];
  const wh = `Warehouse ${(index % 4) + 1}`;
  const importNo =
    index === 0 ? 'HMMU4971909' : `MSKU${7000000 + i}`;
  const emptyNo =
    index === 0 ? 'TGHU3333333' : `TGHU${8000000 + i}`;
  const jobId = `DP-${1000 + i}`;
  const phase = index % 4;
  const shift = phase * 0.03;
  const returnDist = index === 0 ? 18 : 8 + (index % 15);

  return {
    id: `dp-${String(i).padStart(2, '0')}`,
    distanceMiles: returnDist,
    searchContainers: [importNo, emptyNo],
    status: index % 3 === 0 ? 'Booked' : index % 3 === 1 ? 'Pending' : 'Open',
    badges: ['Same Warehouse', `Job ${jobId}`, term],
    headerHint: HEADER_HINT,
    columnGroups: [
      {
        title: 'Dropped Import',
        rows: [
          { label: 'Container', value: importNo },
          { label: 'Size / Type', value: '40HC' },
          { label: 'SSL', value: ssl },
          { label: 'Delivery Appt', value: 'Apr 6, 8:00 AM' },
          { label: 'City', value: city },
          { label: 'Warehouse', value: wh },
        ],
      },
      {
        title: 'Picked Empty',
        rows: [
          { label: 'Container', value: emptyNo },
          { label: 'Size / Type', value: '40HC' },
          { label: 'SSL', value: ssl },
          { label: 'Became Empty', value: 'Apr 5, 12:30 PM' },
          { label: 'From Warehouse', value: wh },
        ],
      },
      {
        title: 'Planner Milestones',
        rows: [
          {
            label: 'Buffer Applied',
            value: 'Apr 6, 9:30 AM (1.5 hr buffer)',
          },
          { label: 'Target Return', value: 'Apr 6, 10:45 AM' },
          { label: 'Window Start', value: 'Apr 6, 9:45 AM' },
          { label: 'Window End', value: 'Apr 6, 11:45 AM' },
          { label: 'Appointments Booked', value: 'Apr 6, 10:45 AM' },
          { label: 'Appointment Used', value: 'Apr 6, 10:45 AM' },
        ],
      },
    ],
    timeline: {
      windowStartLabel: 'Apr 6, 8:00 AM',
      windowEndLabel: 'Apr 6, 12:30 PM',
      nodes: [
        {
          id: 'dp-n1',
          p: Math.min(0.92, 0.22 + shift),
          apiColor: '#9333EA',
          title: 'Buffer Applied',
          time: 'Apr 6, 9:30 AM',
        },
        {
          id: 'dp-n2',
          p: Math.min(0.92, 0.38 + shift),
          apiColor: '#F5C542',
          title: 'AutoBook Window Start',
          time: 'Apr 6, 9:45 AM',
        },
        {
          id: 'dp-n3',
          p: Math.min(0.92, 0.55 + shift),
          apiColor: '#60A5FA',
          title: 'Appointment Booked',
          time: 'Apr 6, 10:45 AM',
        },
        {
          id: 'dp-n4',
          p: Math.min(0.92, 0.78 + shift),
          apiColor: '#F5C542',
          title: 'AutoBook Window End',
          time: 'Apr 6, 11:45 AM',
        },
      ],
    },
    movementSegments: [
      { type: 'place', label: wh },
      { type: 'leg' },
      { type: 'place', label: wh },
      { type: 'leg', miles: returnDist },
      { type: 'place', label: term },
    ],
  };
}

const dropPickPlannerTestData = Array.from({ length: 35 }, (_, k) =>
  buildDropPickPlannerCard(k)
);

export default dropPickPlannerTestData;
